export default "__VITE_ASSET__GHA02Zfp__"